import { render, staticRenderFns } from "./AuthorSort.vue?vue&type=template&id=4c05518f&scoped=true"
import script from "./AuthorSort.vue?vue&type=script&lang=js"
export * from "./AuthorSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c05518f",
  null
  
)

export default component.exports